const problems = [
  {
    tag: 'Berufstätige',
    icon: 'ri-briefcase-4-line',
    title: 'Nach einem langen Tag fehlt die Energie – und morgen ist es wieder so.',
    text: 'Nicht wegen Faulheit. Wegen Realität. Arbeit, Pendeln, Familie. Bis Feierabend ist die Kraft weg. Das ist kein persönliches Versagen – das ist ein Strukturproblem. Und das lässt sich lösen.',
  },
  {
    tag: 'Rücken & Beschwerden',
    icon: 'ri-body-scan-line',
    title: 'Das Ziehen im Rücken sitzt seit Jahren. Training hat es nie gelöst.',
    text: 'Viele kamen zu uns nach Physiotherapie, Yoga, Chiropraktik – und nach Jahren ohne wirkliche Verbesserung. EMS wirkt in die Tiefe: dort, wo klassisches Training nicht hinkommt, und sanft genug für belastete Gelenke.',
  },
  {
    tag: 'Anonymes Fitnessstudio',
    icon: 'ri-building-line',
    title: 'Gym-Abo, zweimal gegangen, dann irgendwie aufgehört.',
    text: 'Niemand hat erklärt, was zu dir passt. Kein Trainer, der deinen Namen kennt. Kein Programm, das auf deinen Körper eingeht. Generisches Training liefert generische Ergebnisse – meistens keine.',
  },
  {
    tag: 'Figur & Motivation',
    icon: 'ri-scales-3-line',
    title: 'Du weißt, was du willst. Aber allein fehlt die Verbindlichkeit.',
    text: 'Ziele setzen ist einfach. Dranbleiben allein ist schwer. Ohne jemanden, der dich kennt und begleitet, verliert sich das meiste im Alltag. Das ist keine Schwäche – das ist menschlich.',
  },
];

export default function ProblemSection() {
  return (
    <section id="problem" className="py-24 md:py-32" style={{ backgroundColor: '#0A1510' }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="max-w-2xl mb-16">
          <span
            className="text-xs font-medium tracking-[0.22em] uppercase"
            style={{ fontFamily: 'Inter, sans-serif', color: '#5DC48E' }}
          >
            Kommt dir das bekannt vor?
          </span>
          <h2
            className="text-3xl md:text-[50px] font-bold text-white mt-5 leading-[1.08]"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Du willst es.<br />
            <span style={{ color: 'rgba(255,255,255,0.2)' }}>Das System macht es schwer.</span>
          </h2>
          <p
            className="text-sm mt-5 leading-relaxed max-w-lg"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300, color: 'rgba(255,255,255,0.35)' }}
          >
            Vier Muster, die wir jeden Tag hören – von Menschen, die heute bei uns trainieren.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {problems.map((p, i) => (
            <div
              key={i}
              className="rounded-2xl p-7 border cursor-default transition-all duration-300 group"
              style={{ backgroundColor: '#111A15', borderColor: 'rgba(93,196,142,0.08)' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'rgba(93,196,142,0.22)';
                e.currentTarget.style.backgroundColor = '#141F18';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'rgba(93,196,142,0.08)';
                e.currentTarget.style.backgroundColor = '#111A15';
              }}
            >
              <div className="flex items-center gap-3 mb-5">
                <div
                  className="w-8 h-8 flex items-center justify-center rounded-xl flex-shrink-0"
                  style={{ backgroundColor: 'rgba(93,196,142,0.1)' }}
                >
                  <i className={`${p.icon} text-sm`} style={{ color: '#5DC48E' }}></i>
                </div>
                <span
                  className="inline-flex items-center text-xs font-medium tracking-widest uppercase px-3 py-1 rounded-full border whitespace-nowrap"
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    color: '#5DC48E',
                    borderColor: 'rgba(93,196,142,0.2)',
                    backgroundColor: 'rgba(93,196,142,0.06)',
                  }}
                >
                  {p.tag}
                </span>
              </div>
              <h3
                className="text-white font-semibold text-lg leading-snug mb-3.5"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {p.title}
              </h3>
              <p
                className="text-sm leading-relaxed"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300, color: 'rgba(255,255,255,0.38)' }}
              >
                {p.text}
              </p>
            </div>
          ))}
        </div>

        {/* Quote + CTA */}
        <div className="mt-16 pt-12 border-t" style={{ borderColor: 'rgba(255,255,255,0.07)' }}>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
            <div className="max-w-2xl">
              <p
                className="text-xl md:text-[26px] leading-relaxed"
                style={{ fontFamily: 'Cormorant Garamond, serif', color: 'rgba(255,255,255,0.8)', fontStyle: 'italic' }}
              >
                „Es ist nicht deine Schuld. Du hast bisher einfach das
                falsche System genutzt. Und das lässt sich ändern –
                in 20 Minuten pro Woche."
              </p>
              <p className="text-xs mt-5" style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(93,196,142,0.5)' }}>
                — Das Team von Körperformen Pinneberg
              </p>
            </div>
            <div className="flex-shrink-0">
              <button
                onClick={() => { const el = document.getElementById('loesung'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}
                className="text-sm font-medium px-6 py-3 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap border"
                style={{
                  fontFamily: 'Inter, sans-serif',
                  color: '#5DC48E',
                  borderColor: 'rgba(93,196,142,0.25)',
                  backgroundColor: 'rgba(93,196,142,0.06)',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(93,196,142,0.13)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'rgba(93,196,142,0.06)'; }}
              >
                Und die Lösung? →
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
